const state = {
  query: {},
  cardNo: '',
  current: {},
  info: {},
  iveInfo: [],
  list: [],
  nowiszp: false,
  nowCardStatus: false,
  node: {},
  transIdList: [],
  checkedIndexList: [],
  checkedIdList: [],
  account: {},
  input: {},
  merges: '',
  tip: '',
  elclist: {},
  invoiceType: '',
  checkedList: [],
  oldInput: {},
  bzList: [],
  tempMoney: '',
  checkAll: false,
  showAdd: '',
  nodeData: {
    cityName: '',
    areaName: '',
    nodeName: '',
    cityCode: '',
    areaCode: '',
    nodeNo: '',
    tel: '',
    address: ''
  },
  vatautoconf: {},
  // 是否拆分发票
  isMore: false,
  openPdf: false
}

const getters = {}

const trim = value => {
  return value ? value.trim() : ''
}

const mutations = {
  SET_INVOICETYPE(state, invoiceType) {
    state.invoiceType = invoiceType
  },
  SET_ELC_LIST(state, elclist) {
    state.elclist = elclist
  },
  SET_CHECK_ALL(state, checkAll) {
    state.checkAll = checkAll
  },
  SET_BZ_LIST(state, bzList) {
    state.bzList = bzList
  },
  SET_CARD_STATUS(state, nowCardStatus) {
    state.nowCardStatus = nowCardStatus
  },
  SET_VATA_DATA(state, vatautoconf) {
    state.vatautoconf = vatautoconf
  },
  SET_IS_ZP(state, nowiszp) {
    state.nowiszp = nowiszp
  },
  SET_OPEN_PDF(state, openPdf) {
    state.openPdf = openPdf
  },
  SET_TEMP_MONEY(state, money) {
    state.tempMoney = money
  },
  SET_QUERY_MERGE(state, merges) {
    state.merges = merges
  },
  SET_NODE_DATA(state, nodeData) {
    state.nodeData.cityName = nodeData.cityName
    state.nodeData.areaName = nodeData.areaName
    state.nodeData.nodeName = nodeData.nodeName
    state.nodeData.cityCode = nodeData.cityCode
    state.nodeData.areaCode = nodeData.areaCode
    state.nodeData.nodeNo = nodeData.nodeNo
    state.nodeData.tel = nodeData.tel
    state.nodeData.address = nodeData.address
  },
  SET_CHECK_LIST(state, checkedList) {
    state.checkedList = checkedList
  },
  SET_QUERY_ISMORE(state, isMore) {
    state.isMore = isMore
  },
  SET_CARDNUMBER(state, cardNo) {
    state.cardNo = cardNo
  },
  SET_TRANSID(state, transIdList) {
    state.transIdList = transIdList
  },
  SET_IVEINFO(state, iveInfo) {
    state.iveInfo = iveInfo
  },
  SET_TIP(state, tip) {
    if (tip && tip.length) {
      state.tip = tip
    }
  },
  SET_INPUT(state, { sendFlag, custName, sendAddr, mobile, money, cityName }) {
    state.input.sendFlag = sendFlag
    state.input.custName = custName
    state.input.sendAddr = sendAddr
    state.input.mobile = mobile
    state.input.money = money
    state.input.cityName = cityName
  },
  SET_INPUT_TEL(state, value) {
    state.oldInput.custName = value.custName
    state.oldInput.mobile = value.mobile
    state.oldInput.sendFlag = value.sendFlag
    state.oldInput.sendAddr = value.sendAddr
  },
  SET_QUERY_DATA(state, { query, account, list }) {
    state.query = query
    state.account = account
    state.list = list
    state.current = {}
    state.checkedIndexList = []
    state.checkedIdList = []
    state.input = {}
  },
  SET_CHECKED_DATA(state, { current, checkedIndexList }) {
    state.current = current
    state.checkedIndexList = checkedIndexList

    const list = state.list
    const checkedIdList = []
    checkedIndexList.forEach(index => {
      const row = list[index]
      const { tradeType, tradeClass, transId, transNo, taxrate } = row
      checkedIdList.push(
        trim(tradeType) + '_' + trim(tradeClass) + '_' + trim(transId) + '_' + trim(transNo) + '_' + trim(taxrate)
      )
    })

    state.checkedIdList = checkedIdList
  },
  SET_QUERY_PRAMS(state, { query }) {
    state.query = query
  },
  SET_NODE(state, { node }) {
    state.node = node
  },
  SET_SHOWADD(state, { query }) {
    state.showAdd = query
  },
  SET_CHECKED(state, { current, list, checkedIndexList, info, account }) {
    state.current = current
    state.list = list
    state.checkedIndexList = checkedIndexList
    state.info = info
    state.account = account

    const checkedIdList = []
    checkedIndexList.forEach(index => {
      const row = list[index]
      const { tranSeq, tranId } = row
      checkedIdList.push(tranSeq + tranId)
    })

    state.checkedIdList = checkedIdList
  },
  SET_CHECKED_SUM(state, { current, list, checkedIndexList, info, account }) {
    state.current = current
    state.list = list
    state.checkedIndexList = checkedIndexList
    state.info = info
    state.account = account

    const checkedIdList = []
    checkedIndexList.forEach(index => {
      const row = list[index]
      const { tradeType, tradeclass } = row
      checkedIdList.push(tradeType + tradeclass)
    })

    state.checkedIdList = checkedIdList
  },
  // SET_CHECKED(state, { list, checkedIndexList, amt, totalAmt, iveAccNo }) {
  //   state.transList = list
  //   state.checkedIndexList = checkedIndexList
  //   state.amt = amt
  //   state.totalAmt = totalAmt
  //   state.iveAccNo = iveAccNo

  //   const checked = []
  //   checkedIndexList.forEach(v => {
  //     const row = list[v]
  //     checked.push(row.tranSeq + row.tranId)
  //   })
  //   state.checkedList = checked
  // },
  RESET(state) {
    state.query = {}
    state.current = {}
    state.info = {}
    state.list = []
    state.node = {}
    state.checkedIndexList = []
    state.checkedIdList = []
    state.account = {}
  }
}

const actions = {
  setQueryPrams({ commit }, query) {
    commit('SET_QUERY_PRAMS', query)
  },
  setNode({ commit }, node) {
    commit('SET_NODE', node)
  },
  checked({ commit }, { current, list, checkedIndexList, info, account }) {
    commit('SET_CHECKED', { current, list, checkedIndexList, info, account })
  },
  checkedSum({ commit }, { current, list, checkedIndexList, info, account }) {
    commit('SET_CHECKED_SUM', { current, list, checkedIndexList, info, account })
  },
  reset({ commit }) {
    commit('RESET')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
